import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import { startLoading, doneLoading } from '../../../utils/loading'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import BookingManagementScholarsWidget from '../../../widgets/durableArticlesWidget/bookingManagementScholarsWidget/BookingManagementScholarsWidget'

export default function BookingManagementScholars() {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()

  const mockSchema = {
    affectedRows: 5,
    message: 'Successfully',
    success: true,
    didError: false,
    errorMessage: null,
    model: {
      header: 'นักวิชาการ จัดการรายการขอจอง',
      subHeader: '',
      disabled: false,
      form: {
        search: {
          projectCode: {
            name: 'projectCode',
            label: 'รหัสโครงการ',
            value: '66-00145',
          },
          projectName: {
            name: 'projectName',
            label: 'ชื่อโครงการ',
            value: '',
          },
          projectStatus: {
            label: 'สถานะ',
            name: 'projectStatus',
            options: [
              {
                disabled: false,
                label: 'จอง',
                value: '1',
              },
              {
                disabled: false,
                label: 'นำไปใช้ใหม่',
                value: '2',
              },
              {
                disabled: false,
                label: 'ยกเลิกการจอง',
                value: '3',
              },
              {
                disabled: false,
                label: 'หมดอายุจอง',
                value: '4',
              },
            ],
          },
          startDateBooking: {
            label: 'วันที่ขอจองเริ่มต้น',
            name: 'startDateBooking',
            value: '',
          },
          stopDateBooking: {
            label: 'วันที่ขอจองสิ้นสุด',
            name: 'stopDateBooking',
            value: '',
          },
          bookingExpirationDate: {
            label: 'วันที่หมดอายุการจองเริ่มต้น',
            name: 'bookingExpirationDate',
            value: '',
          },
          bookingExpirationStopDate: {
            label: 'วันที่หมดอายุการจองสิ้นสุด',
            name: 'bookingExpirationStopDate',
            value: '',
          },
          bookingName: {
            label: 'ผู้ขอจองครุภัณฑ์',
            name: 'bookingName',
            value: '',
          },
          typeEquipment: {
            label: 'ประเภทครุภัณฑ์ ',
            name: 'typeEquipment',
            options: [
              {
                disabled: false,
                label: 'ครุภัณฑ์สำนักงาน',
                value: '1',
              },
              {
                disabled: false,
                label: 'ครุภัณฑ์ไฟฟ้าและวิทยุ',
                value: '2',
              },
              {
                disabled: false,
                label: 'ครุภัณฑ์งานบ้านงานครัว',
                value: '3',
              },
              {
                disabled: false,
                label: 'ครุภัณฑ์โฆษณาและเผยแพร่',
                value: '4',
              },
              {
                disabled: false,
                label: 'ครุภัณฑ์วิทยาศาสคร์และการแพทย์',
                value: '5',
              },
              {
                disabled: false,
                label: 'ครุภัณฑ์คอมพิวเตอร์',
                value: '6',
              },
              {
                disabled: false,
                label: 'ครุภัณฑกีฬา',
                value: '7',
              },
              {
                disabled: false,
                label: 'ครุภัณฑ์อื่นๆ',
                value: '8',
              },
            ],
          },
          nameEquipment: {
            label: 'ชื่อครุภัณฑ์',
            name: 'nameEquipment',
            value: '',
          },
          note: {
            label: 'ระบุหมายเหตุอื่นๆ',
            name: 'note',
            value: '',
          },
          projectType: {
            label: 'ขอจองไปใช้กับโครงการ ',
            name: 'projectType',
            optionSelected: 0,
            options: [
              {
                disabled: false,
                label:
                  '66-10092 : ออกแบบและพัฒนากลยุทธ์ส่งเสริมการสร้างเครือข่ายศูนย์เรียนรู้การสร้างเสริมสุขภาวะองค์กร ระยะที่ 2',
                value: '1',
              },
              {
                disabled: false,
                label: '66-10901 : พัฒนาคุณภาพโลกร้อน',
                value: '2',
              },
              {
                disabled: false,
                label: '-- เลือกโครงการที่จะโอนไปใช่งานต่อ--',
                value: '3',
              },
            ],
            validators: [
              { type: 'REQUIRED', value: null, errorMessage: 'กรุณากรอกขอจองไปใช้กับโครงการ ' },
            ],
          },
        },
        formTable: {
          total: 4,
          values: [
            {
              id: '1',
              assetCode: 'XXX-000-111',
              assetName: 'วัสดุคอมพิวเตอร์',
              pricePerUnit: 25000,
              brand: 'Asus',
              model: 'Asus GT300 (MM1234)',
              assetType: '',
              bookingOfDepartment: 'สำนัก 1',
              coodinator: 'ชื่อ-สกุล นักวิชาการ',
              bookingStatus: 'is_booking',
              bookingStatusName: 'จอง',
              expirationDate: '3/12/2023',
              assetImage: [],
              note: '',
              assetDocument: ['เอกสาร พน.3.pdf'],
            },
            {
              id: '2',
              assetCode: 'XXX-000-111',
              assetName: 'วัสดุคอมพิวเตอร์',
              pricePerUnit: 25000,
              brand: 'Asus',
              model: 'Asus GT300 (MM1234)',
              assetType: '',
              bookingOfDepartment: 'สำนัก 1',
              coodinator: 'ชื่อ-สกุล นักวิชาการ',
              bookingStatus: 'is_booking',
              bookingStatusName: 'จอง',
              expirationDate: '3/12/2023',
              assetImage: [],
              note: '',
              assetDocument: ['เอกสาร พน.3.pdf'],
            },
            {
              id: '3',
              assetCode: 'XXX-000-111',
              assetName: 'วัสดุคอมพิวเตอร์',
              pricePerUnit: 25000,
              brand: 'Asus',
              model: 'Asus GT300 (MM1234)',
              assetType: '',
              bookingOfDepartment: 'สำนัก 1',
              coodinator: 'ชื่อ-สกุล นักวิชาการ',
              bookingStatus: 'is_booking',
              bookingStatusName: 'จอง',
              expirationDate: '3/12/2023',
              assetImage: [],
              note: '',
              assetDocument: ['เอกสาร พน.3.pdf'],
            },
            {
              id: '3',
              assetCode: 'XXX-000-111',
              assetName: 'วัสดุคอมพิวเตอร์',
              pricePerUnit: 25000,
              brand: 'Asus',
              model: 'Asus GT300 (MM1234)',
              assetType: '',
              bookingOfDepartment: 'สำนัก 1',
              coodinator: 'ชื่อ-สกุล นักวิชาการ',
              bookingStatus: 'is_expire',
              bookingStatusName: 'จอง',
              expirationDate: '3/12/2023',
              assetImage: [],
              note: '',
              assetDocument: ['เอกสาร พน.3.pdf'],
            },
          ],
        },
      },
    },
  }

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      // const request = {
      //   lawType: null,
      //   projectCode: null,
      //   docNumberOfPurchase: null,
      //   contractNumberRef: null,
      //   pageNumber: 1,
      //   pageSize: 5,
      // }

      // const _schema = await getLegalManagement(request)
      // console.log('getLegalManagement ', _schema)
      setSchema(mockSchema)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isIncomeExpenseApprover>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isIncomeExpenseApprover>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <div>
      <SidebarProposal isIncomeExpenseApprover>
        <ContentHeader header={schema.model.header} subHeader={''} isNotCallApi />
        <BookingManagementScholarsWidget schema={schema.model} />
        <br />
      </SidebarProposal>
    </div>
  )

  /* 
  {
              id: '2',
              requester: 'ชื่อ-สกุล นักวิชาการ',
              activity: 'วัสดุสำนักงาน',
              equipmentCode: 'XXX-000-112',
              nameEquipment: 'ครุภัณฑ์ 2',
              amount: 10000,
              EquipmentModel: '',
              brand: '',
              EquipmentType: '',
              bookingStatus: 'จอง',
              bookingDepartment: 'สำนัก 1',
              bookingDeadline: '3/12/2023',
              documentName: 'ใบขอเปิดรายงาน.pdf',
              notation: '-',
              isDeletable: true,
            },
            {
              id: '3',
              requester: 'ชื่อ-สกุล นักวิชาการ',
              activity: 'วัสดุสำนักงาน',
              equipmentCode: 'XXX-000-112',
              nameEquipment: 'ครุภัณฑ์ 3',
              amount: 10000,
              EquipmentModel: '',
              brand: '',
              EquipmentType: '',
              bookingStatus: 'จอง',
              bookingDepartment: 'สำนัก 1',
              bookingDeadline: '3/12/2023',
              documentName: 'ใบขอเปิดรายงาน.pdf',
              notation: '-',
              isDeletable: true,
            },
            {
              id: '4',
              requester: 'ชื่อ-สกุล นักวิชาการ',
              activity: 'วัสดุสำนักงาน',
              equipmentCode: 'XXX-000-112',
              nameEquipment: 'ครุภัณฑ์ 4',
              amount: 10000,
              EquipmentModel: '',
              brand: '',
              EquipmentType: '',
              bookingStatus: 'หมดอายุจอง',
              bookingDepartment: 'สำนัก 1',
              bookingDeadline: '3/12/2023',
              documentName: 'เอกสาร พน.3.pdf',
              notation: '-',
              isDeletable: true,
            },


            projectType: {
            label: 'ขอจองไปใช้กับโครงการ ',
            name: 'projectType',
            optionSelected: 0,
            options: [
              {
                disabled: false,
                label:
                  '66-10092 : ออกแบบและพัฒนากลยุทธ์ส่งเสริมการสร้างเครือข่ายศูนย์เรียนรู้การสร้างเสริมสุขภาวะองค์กร ระยะที่ 2',
                value: '1',
              },
              {
                disabled: false,
                label: '66-10901 : พัฒนาคุณภาพโลกร้อน',
                value: '2',
              },
              {
                disabled: false,
                label: '-- เลือกโครงการที่จะโอนไปใช่งานต่อ--',
                value: '3',
              },
            ],
            validators: [
              { type: 'REQUIRED', value: null, errorMessage: 'กรุณากรอกขอจองไปใช้กับโครงการ ' },
            ],
          },
  */
}
